import {REST_METHODS} from '@/src/app/constants/api';
import authorizedFetch from '@/src/app/utils/authorizedFetch';

const updateAddress = (city_id: number): Promise<any> => {
  // @ts-ignore
  return authorizedFetch({
    method: REST_METHODS.POST,
    path: `/api/v1/profiles/profiles`,
    body: {
      profile: {
        city_id,
      },
    },
  });
};

export default updateAddress;
